import React from "react";
import { Button, CircularProgress } from "@mui/material";

const SubmitButtonWithLoader = ({
  loading,
  onClick,
  children,
  submittingText = "Submitting...",
  ...props
}) => {
  return (
    <Button
      onClick={onClick}
      disabled={loading}
      variant="contained"
      sx={{
        textTransform: "none",
        fontWeight: 500,
        minWidth: 120,
        ...props.sx,
      }}
      {...props}
    >
      {loading ? submittingText : children}
      {loading && <CircularProgress size={20} sx={{ color: "green", ml: 1 }} />}
    </Button>
  );
};

export default SubmitButtonWithLoader;
